import {t} from '../../common/getTranslations';
import {RouletteWinPrizeTypeVo} from '../../common/shared/api/nicolas/vo/enums/RouletteWinPrizeTypeVo.enum';

export function createRoulettePrize(prize = '', type?: RouletteWinPrizeTypeVo) {
  return type
    ? type === RouletteWinPrizeTypeVo.Cash
      ? t('common_cash_amount', {values: {value: prize}})
      : prize
    : undefined;
}
